const styles = ({ COLORS }) => ({
  container: {
    maxWidth: '50%',
    textAlign: 'center',
    fontSize: '16px',
    margin: '20px auto 40px',
    lineHeight: '24px'
  },
  link: {
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL,
    textDecoration: 'none'
  },
  illustration: {
    margin: '20px auto',
    display: 'block',
    maxWidth: '200px'
  },
  archived: {
    textAlign: 'right',
    marginTop: '20px'
  },
  pagination: {
    marginTop: '20px',
    display: 'flex',
    justifyContent: 'center'
  }
})

export default styles
